import * as React from 'react';
import ChangePasswordComponent from '../components/ChangePasswordComponent';
import { ChangePassWord } from '../services/main/main.model';
import { withRouter, RouteComponentProps, Redirect } from 'react-router-dom';
import Header from '../components/Header/LoginHeader';
import { connect } from 'react-redux';
import { login, alertActions, changePassword } from '../services/main/main.action';
import Auth from '../modules/Auth';
import { MSG_CHANGE_PASSWORD } from '../constants/MSG';

type State = {
  changePassword: ChangePassWord
};

type DispatchToProps = {
  login: (username: string, password: string) => void,
  handleError:(message:string)=> void,
  changePassword:(currentPassword: string, newPassword: string) => void
};

type StateToProps = {
}

type Props = {
} & RouteComponentProps<null> & DispatchToProps & StateToProps;

class ChangePasswordPage extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      changePassword: {
        currentPassword: '',
        newPassword: '',
        repeatPassword: '',
      },
    };
  }

  processForm(event: any) {
    event.preventDefault();
    const { currentPassword, newPassword, repeatPassword } = this.state.changePassword;
    if (currentPassword && newPassword && repeatPassword) {
      if (newPassword === repeatPassword) {
        this.props.changePassword(currentPassword, newPassword)
      }else{
        this.props.handleError(MSG_CHANGE_PASSWORD.UN_EQUAL_PASSWORD)
      }
    }
  }

  changeUser(event: any) {
    const field = event.target.name;
    const changePasswordData = { ...this.state.changePassword };
    changePasswordData[field] = event.target.value;
    this.setState({
      changePassword: changePasswordData
    });
  }
  renderChangePassword(){
    const { changePassword } = this.state;
    return (
      <div className="login change-password">
        <ChangePasswordComponent
          onSubmit={this.processForm.bind(this)}
          onChange={this.changeUser.bind(this)}
          user={changePassword}
        />
      </div>
    );
  }
  render() {
    if (Auth.isUserAuthenticated()) {
      return this.renderChangePassword()
    }
    return <Redirect to="/login" />
  }
}

const mapDispatchToProps = (dispatch: Function): DispatchToProps => ({
  login: (username: string, password: string) => dispatch(login(username, password)),
  handleError:(message:string)=> dispatch(alertActions.error(message)),
  changePassword:(currentPassword:string, newPassword: string)=> dispatch(changePassword(currentPassword, newPassword))
});

export default withRouter(connect(null, mapDispatchToProps)(ChangePasswordPage));
